export const baseUrl = process.env.REACT_APP_CD_API